<div class="header">
  <h1>🏢 Panel de Administración - REHOBOT</h1>
  <div class="header-actions">
    <button class="btn btn-secondary" (click)="showChangePasswordModal()">🔐 Cambiar Contraseña</button>
    <button class="btn btn-danger" (click)="logout()">🚪 Cerrar Sesión e ir al Index Principal</button>
  </div>
</div>

<div class="container">
  <!-- Estadísticas -->
  <div class="stats">
    <div class="stat-card">
      <h3>Total Contactos</h3>
      <div class="number">{{ stats.total_contactos || 0 }}</div>
      <div class="description">Mensajes recibidos</div>
    </div>
    <div class="stat-card">
      <h3>Contactos Nuevos</h3>
      <div class="number">{{ stats.contactos_nuevos || 0 }}</div>
      <div class="description">Sin responder</div>
    </div>
    <div class="stat-card">
      <h3>Total Aplicaciones</h3>
      <div class="number">{{ stats.total_aplicaciones || 0 }}</div>
      <div class="description">CV recibidos</div>
    </div>
    <div class="stat-card">
      <h3>En Proceso</h3>
      <div class="number">{{ stats.aplicaciones_proceso || 0 }}</div>
      <div class="description">En revisión/entrevista</div>
    </div>
  </div>

  <!-- Botón de recarga manual -->
  <div style="text-align: center; margin: 10px 0;">
    <button class="btn btn-primary" (click)="reloadData()" title="Recargar estadísticas y datos">
      🔄 Actualizar Datos
    </button>
  </div>

  <!-- Pestañas -->
  <div class="tabs">
    <button class="tab" [class.active]="activeTab === 'contactos'" (click)="switchTab('contactos')">📧 Contactos</button>
    <button class="tab" [class.active]="activeTab === 'trabajos'" (click)="switchTab('trabajos')">💼 Aplicaciones de Trabajo</button>
  </div>

  <!-- Contenido de pestañas -->
  <div class="tab-content">
    <!-- Filtros -->
    <div class="filters">
      <div class="filter-group">
        <label>Estado:</label>
        <select [(ngModel)]="filters.estado" (change)="applyFilters()">
          <option value="">Todos</option>
          <ng-container *ngIf="activeTab === 'contactos'">
            <option value="nuevo">Nuevo</option>
            <option value="leido">Leído</option>
            <option value="respondido">Respondido</option>
          </ng-container>
          <ng-container *ngIf="activeTab === 'trabajos'">
            <option value="nuevo">Nuevo</option>
            <option value="revision">En revisión</option>
            <option value="entrevista">Entrevista</option>
            <option value="contratado">Contratado</option>
            <option value="rechazado">Rechazado</option>
          </ng-container>
        </select>
      </div>

      <div class="filter-group">
        <label>Fecha desde:</label>
        <input type="date" [(ngModel)]="filters.fechaDesde" (change)="applyFilters()">
      </div>

      <div class="filter-group">
        <label>Fecha hasta:</label>
        <input type="date" [(ngModel)]="filters.fechaHasta" (change)="applyFilters()">
      </div>

      <div class="filter-group">
        <label>Buscar:</label>
        <input type="text" placeholder="Nombre, email..." [(ngModel)]="filters.buscar" (keyup)="applyFilters()">
      </div>

      <button class="btn btn-secondary" (click)="clearFilters()">Limpiar filtros</button>
      <button class="btn btn-primary" (click)="exportData()">📥 Exportar CSV</button>
    </div>

    <!-- Tabla -->
    <div class="table-container" *ngIf="paginatedData.length > 0; else noData">
      <table id="dataTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th *ngIf="activeTab === 'contactos'">Mensaje</th>
            <th *ngIf="activeTab === 'trabajos'">Puesto</th>
            <th *ngIf="activeTab === 'trabajos'">CV</th>
            <th>Fecha</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedData">
            <td>#{{ item.id }}</td>
            <td>{{ item.nombre }}</td>
            <td><a href="mailto:{{ item.email }}">{{ item.email }}</a></td>
            <td><a href="tel:{{ item.telefono }}">{{ item.telefono }}</a></td>
            
            <td *ngIf="activeTab === 'contactos'" class="message-preview" [title]="item.mensaje">{{ item.mensaje }}</td>
            
            <td *ngIf="activeTab === 'trabajos'">{{ item.puesto }}</td>
            <td *ngIf="activeTab === 'trabajos'">
              <a *ngIf="item.cv_archivo" [href]="'https://corporacionrehobot.com/php/uploads_cv/' + item.cv_archivo" target="_blank" class="file-link">📄 Ver CV</a>
              <span *ngIf="!item.cv_archivo">-</span>
            </td>
            
            <td>{{ formatDate(item.fecha_envio) }}</td>
            <td><span class="status-badge" [ngClass]="'status-' + item.estado?.toLowerCase()">{{ item.estado }}</span></td>
            <td class="action-buttons">
              <button class="btn btn-primary" (click)="updateStatus(item.id, activeTab)">✏️</button>
              <button class="btn btn-danger" (click)="deleteRecord(item.id, activeTab)">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noData>
      <p style="text-align: center; padding: 2rem;">No hay datos para mostrar con los filtros actuales.</p>
    </ng-template>

    <!-- Paginación -->
    <div class="pagination" *ngIf="totalPages > 1">
      <button class="page-btn" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">« Anterior</button>
      <ng-container *ngFor="let page of pages">
        <button class="page-btn" (click)="changePage(page)" [class.active]="currentPage === page">
          {{ page }}
        </button>
      </ng-container>
      <button class="page-btn" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">Siguiente »</button>
    </div>
  </div>
</div>

<!-- Modal para cambiar contraseña -->
<div class="modal" *ngIf="isModalVisible" (click)="hideChangePasswordModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>🔐 Cambiar Contraseña</h3>
      <button class="modal-close" (click)="hideChangePasswordModal()">&times;</button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="changePassword(); $event.preventDefault()">
        <!-- Hidden CSRF token so native form submits include it if triggered -->
        <input type="hidden" name="csrf_token" [value]="csrfToken">
        <div class="form-group">
          <label for="currentPassword">Contraseña Actual:</label>
          <input type="password" id="currentPassword" name="currentPassword" [(ngModel)]="passwordChange.currentPassword" required>
        </div>
        <div class="form-group">
          <label for="newPassword">Nueva Contraseña:</label>
          <input type="password" id="newPassword" name="newPassword" [(ngModel)]="passwordChange.newPassword" required minlength="8" (input)="checkPasswordStrength()">
          <small>Debe tener al menos 8 caracteres, mayúsculas, minúsculas, números y símbolos</small>
          <div class="password-strength">
             <div class="password-strength-bar" [ngClass]="passwordStrength.class" [style.width.%]="passwordStrength.width"></div>
          </div>
           <div class="password-strength-text" [ngClass]="passwordStrength.textClass">{{ passwordStrength.text }}</div>
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirmar Nueva Contraseña:</label>
          <input type="password" id="confirmPassword" name="confirmPassword" [(ngModel)]="passwordChange.confirmPassword" required>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="hideChangePasswordModal()">Cancelar</button>
          <!-- Use explicit button click to avoid native multipart/form-data submit -->
          <button type="button" class="btn btn-primary" (click)="changePassword()">Cambiar Contraseña</button>
        </div>
      </form>
    </div>
  </div>
</div>
